import { NgModule } from '@angular/core';
import { MatButtonModule, MatDialogModule } from '@angular/material';
import { RouterModule, Routes } from '@angular/router';
import { LayoutModule, SharedModule } from '@app/shared';
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';
import { CityAddEditComponent, CityListComponent } from '@user/components/city';

const routes: Routes = [
  { path: 'list', component: CityListComponent, canActivate: [AuthGuard], data: { title: 'City' } }
];
@NgModule({
  declarations: [CityAddEditComponent, CityListComponent],
  imports: [
    RouterModule.forChild(routes),
    MatDialogModule, MatButtonModule,
    LayoutModule,
    SharedModule
  ],
  entryComponents: [CityAddEditComponent]
})
export class CityModule { }
